import { createAsyncThunk } from "@reduxjs/toolkit";
import referralApi from 'api/referralApi';
import { formatQueryParams } from "helpers/format";
import 'react-toastify/dist/ReactToastify.css';

export const getReferralRules = createAsyncThunk("Rules", async (params: any = {}) => {
  try {
    const response = await referralApi.rules(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const postReferralRule = async (data: any = {}) => {
  try {
    const response = await referralApi.postRule(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putReferralRule = async (id: string | number, data: any = {}) => {
  try {
    const response = await referralApi.putRule(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteReferralRule = async (id: string | number, data: any = {}) => {
  try {
    const response = await referralApi.deleteRule(id, data);
    return response;
  } catch (error) {
    return error;
  }
};
